import {
	groups,
	postLogs,
	getSmsLists,
	postSmsList,
	updateSmsList,
	disableSmsList,
	getFilteredSmsList
} from '@/api/Erp'

export default {
	async getGroups(token) {
		try {
			const response = await groups.get({
				headers: {
					'Authorization': `Bearer ${token}`
				}
			})
			return response
		} catch (error) {
			return error.response
		}
	},
	async getSmsLists(token) {
		try {
			const response = await groups.get({
				headers: {
					'Authorization': `Bearer ${token}`
				}
			})
			return response
		} catch (error) {
			return error.response
		}
	},
	async postCreateLogs(payload, token) {
    try {
      const response = await postLogs.post(
        payload,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      )
      return response
    } catch (error) {
      return error.response
    }
  },
	async getAllGroups(payload) {
		try {
			const response = await getSmsLists.get({
				uriParams: {
					page: payload.page,
					size: payload.size,
					id: payload.id,
				},
				headers: {
					'Authorization': `Bearer ${payload.token}`
				}
			})
			return response
		} catch (error) {
			return error.response
		}
	},
	async updateSmsList(payload, token) {
		try {
		  const { id } = payload;
		  const response = await updateSmsList.put(
			payload,
			{
			  uriParams: {
				id
			  },
			  headers: {
				'Authorization': `Bearer ${token}`
			  }
			}
		  )
		  return response
		} catch (error) {
		  return error.response
		}
	  },
	  async disableSmsList(payload, token) {
		try {
		  const { id } = payload;
		  const response = disableSmsList.delete({
			uriParams: {
			  id
			},
			headers: {
			  'Authorization': `Bearer ${token}`
			}
		  })
		  return response
		} catch (error) {
		  return error.response
		}
	  },
	  async getFilteredSmsLists(payload) {
		try {
			const response = await getFilteredSmsList.get({
				uriParams: {
					page: payload.page,
					size: payload.size,
					listName: payload.listName
				},
				headers: {
					'Authorization': `Bearer ${payload.token}`
				}
			})
			return response
		} catch (error) {
			return error.response
		}
	},
	async postSmsList(payload, token) {
		try {
			const response = await postSmsList.post(
				payload,
				{
					headers: {
						'Authorization': `Bearer ${token}`
					}
				}
			)
			return response
		} catch (error) {
			return error.response
		}
	},
}


// WEBPACK FOOTER //
// ./src/store/modules/messageForm/resources.js